import router, { ViewType } from '@/router'
import { routerAddQueryParam } from '../../Router/Methods/routerAddQueryParam'

export function sidebarPushRightView(view: ViewType, leftReset?: boolean, rightReset?: boolean) {
  // В адресе вид указывается ИМЕНЕМ (left=chats), как его читает RouteManager.
  // Здесь стоял номер из перечисления, и «left=1» разбирался как неизвестный
  // вид: после удаления канала экран оставался на его настройках.
  const chatsView = ViewType[ViewType.chats]

  const url = routerAddQueryParam(window.history.state.current, {
    right: view && !rightReset ? ViewType[view] : null,
    m: null,
    ...(leftReset ? {left: chatsView} : {}),
  })

  if (rightReset && leftReset) {
    router.push(routerAddQueryParam('/chats/0', {left: chatsView, right: null, m: null}))
  } else if (window.history.state.back === url) {
    router.back()
  } else {
    router.push(url)
  }
}
